import qs from 'qs';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const getUserData = (id) => axiosInstance.get(`/users/view/${id}`, { params: pickDevParams });

export const createUser = (payload) => axiosInstance.post('/users/create', qs.stringify({ ...payload, ...pickDevParams }));

export const updateUserData = (id, payload) => axiosInstance.post(`/users/update/${id}`, qs.stringify({ ...payload, ...pickDevParams }));

export const getUsersList = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/users/list', {
    params: { ...parsedPayload, ...pickDevParams },
  });
};

export const getSignInHistory = (id, payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get(`/users/sign-in-history/${id}`, {
    params: { ...parsedPayload, ...pickDevParams },
  });
};

export const getUsersStatuses = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/users/statuses', {
    params: { ...parsedPayload, ...pickDevParams },
  });
};

export const getUsersLevels = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/users/discount-counts', {
    params: { ...parsedPayload, ...pickDevParams },
  });
};

export const changeUserStatusUrl = (id, status) => axiosInstance.post(`/users/change-status/${id}`, qs.stringify({ status, ...pickDevParams }));

export const getUserConfigsUrl = () => axiosInstance.get('/users/configuration', { params: pickDevParams });

export const copyCustomRatesUrl = (from_user_id, to_user_id) => axiosInstance.post(
  '/users/copy-custom-rates',
  qs.stringify({
    from_user_id,
    to_user_id,
    ...pickDevParams,
  }),
);

export const setUserPasswordUrl = (id, password) => axiosInstance.post(`/users/set-password/${id}`, qs.stringify({ password, ...pickDevParams }));

export const massChangeStatusesUrl = (status, users) => axiosInstance.post(
  '/users/mass-change-status',
  qs.stringify({
    status,
    users,
    ...pickDevParams,
  }),
);
export const massResetRatesUrl = (users) => axiosInstance.post('/users/mass-reset-rates', qs.stringify({ users, ...pickDevParams }));

export const massCopyRatesUrl = (from_user, to_users) => axiosInstance.post(
  '/users/mass-copy-rates',
  qs.stringify({
    from_user,
    to_users,
    ...pickDevParams,
  }),
);

export const getUsersCustomRatesUrl = () => axiosInstance.get('/users/users-custom-rates', { params: pickDevParams });

export const getCustomRatesForUser = (id) => axiosInstance.get(`/users/get-custom-rates/${id}`, { params: pickDevParams });

export const updateCustomRates = (id, payload) => axiosInstance.post(`/users/update-custom-rates/${id}`, { ...payload, ...pickDevParams });

export const getActivityLog = (id) => axiosInstance.get(`/users/activity-log/${id}`, { params: pickDevParams });

export const getExportListUrl = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/users/export-list', { params: { ...parsedPayload, ...pickDevParams } });
};

export const makeExportUrl = (payload) => axiosInstance.post('/users/export-make', qs.stringify({ ...payload, ...pickDevParams }));

export const updateDiscount = (id, discount) => axiosInstance.post(`/users/update-discount/${id}`, qs.stringify({ discount, ...pickDevParams }));

export const getUsersTotals = () => axiosInstance.get('/users/totals', { params: pickDevParams });

export const getUsersRefunds = (query) => axiosInstance.get('/users/refunds', { params: { ...query, ...pickDevParams } });

export const getUsersSASignin = (id) => axiosInstance.post(`/auth/super-user/${id}`, pickDevParams);
